import { render, staticRenderFns } from "./PersonAlarmList.vue?vue&type=template&id=42a9d2b3&scoped=true"
import script from "./PersonAlarmList.vue?vue&type=script&lang=js"
export * from "./PersonAlarmList.vue?vue&type=script&lang=js"
import style0 from "./PersonAlarmList.vue?vue&type=style&index=0&id=42a9d2b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a9d2b3",
  null
  
)

export default component.exports